import React from 'react';
import moment from 'moment'
import {DatePicker} from 'material-ui-pickers';
import TextField  from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Divider } from '@material-ui/core';
import InputVirtual from 'components/InputVirtual'
import Backup from '@material-ui/icons/Backup';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import SweetAlert from 'react-bootstrap-sweetalert';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CircularProgress from '@material-ui/core/CircularProgress';
import License from './licenseList';

import {Card, CardBody, CardImg, CardSubtitle, CardText} from 'reactstrap';

import {BASE_URL_JAVAZ_API, BASE_HEADER, FILE_HEADER, BASE_URL_API} from "constants/ActionTypes";

const roleUser = localStorage.getItem('rolename')
const COMPANY_ID = localStorage.getItem('companyId')
const token = localStorage.getItem('apiKey')
const config = {
    headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`
    }
}
//length data for general
const LENGTH_DATA = 20

const options = [
    'SIM A',
    'SIM B',
    'SIM C',
    'SIM AC',
    'Pyxis',
    'SIM AB',
];

const styles = theme => ({
    paper: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
    },
  });

const initialState = {
    // input virtual company
    company: 0,
    company_name: '',
    front_photo: null,
    back_photo: null,
    front_photo_license: null,
    back_photo_license: null,
    front_image: null,
    back_image: null,
    front_image_license: null,
    back_image_license: null,

    errorFullName: false,
    messageFullName: '',

    department: '',
    name: '',
    address: '',
    driver_code: '',
    mobile_no: '',
    birth_date: moment(),
    birth_place: '',
    hired_date: moment(),
    absent: false,
    status: false,
    username: '',
    password: '',
    email: '',
    imei_no: '',
    role_name: '',
    vehicle: 0,
    rfid: '',
    driver_type: '',


    // License Add Sim
    license_name: '',
    driver_license_id: null,
    license_exp_date: moment(),
    license_no: '',
    idxLicense: null,

    licenseData: [],
    departmentData: [],

    openSnack: false,
    messageSnack: '',
    sweetSuccess: false,
    sweetWarning: false,

    isParentClick: false,
    openDialog: false,

    imageDialog: false,
    urlFrontImage: '',
    urlBackImage: '',
    loading: false
}

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class DialogAdd extends React.Component {
    constructor(props) {
        super(props);

        this.showDialog = this.showDialog.bind(this);

    }

    state = initialState

    showDialog() {    
        this.setState({ isParentClick : true });
      };

    componentDidMount() {
        this.setState({company: COMPANY_ID})
        this.props.showDialog(this.showDialog);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.isParentClick == true){
        
            this.setState({
                openDialog: true  // tambahin untuk open dialog state
            })

            this.setState({
                isParentClick : false
            })
        
    }
    }

    // input virtual company =====================================
    
    handleGetSelVirCompanyAddForm = ({id}) => {
        // console.log(id)
        this.setState({company: id})
    }
    //end input virtual company
    getInputVehicle = ({id}) => {
        // console.log(id)
        this.setState({vehicle: id})
    }

    getInputDriverLicense = ({id, license_name}) => {
        // console.log(id, license_name)
        this.setState({driver_license_id: id, license_name})
    }

    getInputRoleName = ({role_name}) => {
        // console.log(role_name)
        this.setState({role_name})
    }

    // Add module
    // Add module
  handleDateChange = (date) => {
    this.setState({birth_date: date});
  };

  handleDateChange3 = (date) => {
    this.setState({hired_date: date});
  };
  
  handleChangeCompanyType = event => {
    this.setState({
      company: event.target.value,
    });
  };
  handleChangeDepartmentType = event => {
    this.setState({
      role_name: event.target.value,
    });
  };
  handleChangeStatus = event => {
    this.setState({
      status: event.target.value,
    });
  };
  handleChangeStatusEdit = event => {
    this.setState({
      statusEdit: event.target.value,
    });
  };

  handleAddLicenseDriver = (param) => {
    const {driver_license_id, license_name, license_exp_date, license_no, licenseData, front_image_license, back_image_license, front_photo_license, back_photo_license} = this.state
    const licenseDate = license_exp_date.format("YYYY-MM-DD")

    if(param === 'tambah'){
        if(license_name !== '' || license_no !== ''){
          const obj = {
              license_name, 
              driver_license: driver_license_id,
              license_exp_date: licenseDate,
              license_no,
              data_front_photo: front_photo_license,
              data_back_photo: back_photo_license,
              front_photo: front_image_license,
              back_photo: back_image_license
            }
            // console.log(obj)
          this.setState({openSnack: true, messageSnack: 'Tambahkan SIM Success', licenseData: [...licenseData, obj]})
          // console.log(licenseData)
        } else {
          this.setState({openSnack: true, messageSnack: 'Please Insert data correctly'})
        }
    }

    this.setState({
        license_name: '',
        license_exp_date: moment(),
        license_no: '',
        front_photo_license: null,
        back_photo_license: null,
        front_image_license: null,
        back_image_license: null
    })
  }

  handleRemoveLicense = (data) => {
    const {licenseData} = this.state
    const idx = licenseData.indexOf(data)
    this.setState({sweetWarning: true, idxLicense: idx})
  }

  handleDelete = async param => {
    if(param === 'batal'){
        // console.log(param)
        this.setState({
            sweetWarning: false,
        })
    } else if (param === 'delete') {
        const {licenseData, idxLicense}  = this.state
        const arr = JSON.parse(JSON.stringify(licenseData));
        arr.splice(idxLicense, 1)
        this.setState({licenseData: arr, sweetWarning: false, sweetSuccess: true})
        // console.log(licenseData)
       
    }
  }
  //end Add mdule

  getFrontPhoto= event => {
        this.setState({
            front_photo: event.target.files[0],
            front_image: URL.createObjectURL(event.target.files[0])
        })

        console.log(URL.createObjectURL(event.target.files[0]))
        console.log(event.target.files[0])
  }

  getFrontPhotoLicense = event => {
    this.setState({
        front_photo_license: event.target.files[0],
        front_image_license: URL.createObjectURL(event.target.files[0])
    })

    // console.log(URL.createObjectURL(event.target.files[0]))
}

  getBackPhotoLicense = event => {
        this.setState({
            back_photo_license: event.target.files[0],
            back_image_license: URL.createObjectURL(event.target.files[0])
        })

        // console.log(URL.createObjectURL(event.target.files[0]))
  }

  handleAddNewDriver = async data => {
    let obj = JSON.stringify(data)
    const url = `${BASE_URL_JAVAZ_API}/driver/new`
    const result = await axios.post(url, obj, config).then(res => res).catch(error => error.response)
    return result
  }

  setImage = () => {
    const url = `${BASE_URL_API}/images/driver/${companyIdGlobal}/${user_id}.png?apikey=${token}`
    this.setState({image: url})
  }

  handleChangePhoto = async (id,) => {
    const {front_photo} = this.state
    
    const formData = new FormData()
    formData.append(
      'file',
      front_photo,
      front_photo.name
    )
    // console.log(formData)
    // const obj = JSON.stringify(data)
    const url =  `${BASE_URL_API}/driver/change-photo/${id}`
    const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
    return result
  }
  
  handleChangeFrontPhotoLicense = async (id, data) => {
    const {driver_license, data_front_photo } = data
    
    const formData = new FormData()
    formData.append(
      'file',
      data_front_photo,
      data_front_photo.name
    )
    // console.log(formData)
    // const obj = JSON.stringify(data)
    const url =  `${BASE_URL_API}/driver-license-detail/change-front-photo/${id}/${driver_license}`
    const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
    return result
  }
  
  handleChangeBackPhotoLicense = async (id, data) => {
    const {driver_license, data_back_photo } = data
    
    const formData = new FormData()
    formData.append(
      'file',
      data_back_photo,
      data_back_photo.name
    )
    // console.log(formData)
    // const obj = JSON.stringify(data)
    const url =  `${BASE_URL_API}/driver-license-detail/change-back-photo/${id}/${driver_license}`
    const result = await axios.post(url, formData, FILE_HEADER).then(res => res).catch(err => err.response)
    return result
  }

  handleImageLicense = data => {
    // console.log(data)
    this.setState({
        imageDialog: true,
        urlFrontImage: data.front_photo,
        urlBackImage: data.back_photo
    })
  }

  handleUploadLicenseImage = id => {
    const {licenseData} = this.state
    // console.log(licenseData)
    licenseData.map(async res => {
        if(res.data_front_photo !== null){
            const result2 = await this.handleChangeFrontPhotoLicense(id, res)
            // console.log(result2)
            if(result2.data.status !== true){
                NotificationManager.error(result2.data.message, 'Error message')
                return false
            }
        }
    
        if(res.data_back_photo !== null){
            const result2 = await this.handleChangeBackPhotoLicense(id, res)
            // console.log(result2)
            if(result2.data.status !== true){
                NotificationManager.error(result2.data.message, 'Error message')
                return false
            }
        }
    })
    
  }

  handleSave = async param => {
    const {address, birth_date, birth_place, driver_code, mobile_no, rfid, status, company, name, vehicle, 
            hired_date, absent, email, username, password, imei_no, role_name, licenseData, driver_type} = this.state
    
    if(param === 'batal'){
        // console.log(param)
        // this.props.handleClose(param)
        this.setState(initialState)
    } else if (param === 'tambah') {
        const obj = {
            address,
            driver_code, 
            mobile_no, 
            rfid, status, 
            vehicle: parseInt(vehicle), 
            birth_place,
            company: parseInt(company), 
            name, 
            hired_date, 
            absent, 
            email, 
            username, 
            password, 
            imei_no, 
            driver_type,
            role_name,
            locked: false, 
            birth_date: birth_date.format('YYYY-MM-DD'), 
            hired_date: hired_date.format('YYYY-MM-DD'),
            driver_license: licenseData
        }
        this.setState({ loading: true })
        // console.log(obj)
        const result = await this.handleAddNewDriver(obj)
        // console.log(result)
        if(result.data.code === 201){
            if(this.state.front_photo !== null){
                const result2 = await this.handleChangePhoto(result.data.data.id)
                // console.log(result2)
                if(result2.data.status !== true){
                    NotificationManager.error(result.data.message, 'Error message')
                    return false
                }
            }

            this.handleUploadLicenseImage(result.data.data.id)


            NotificationManager.success('Add Driver Success', 'Success message')
            this.props.closeDialog(param)
            this.setState(initialState)
        } else {
            NotificationManager.error(result.data.message, 'Error message')
        }
            
    }

   
  }

    render() {
        const {classes} = this.props
        const { licenseExpire, departmentData,
            licenseType, licenseData, birthDriverEdit, licenseExpireEdit, licenseTypeEdit, licenseDataEdit,
            errorFullName, messageFullName, loading } = this.state;
        return (
            <React.Fragment>
                <SweetAlert show={this.state.sweetSuccess} success title='Success' onConfirm={() => this.setState({sweetSuccess: false})}>
                    License was successfully deleted !
                </SweetAlert>
                <SweetAlert show={this.state.sweetWarning}
                            warning
                            showCancel
                            confirmBtnText='Yes Delete!'
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="default"
                            title='Are You Sure?'
                            onConfirm={() => this.handleDelete('delete')}
                            onCancel={() => this.handleDelete('batal')}
                >
                    You want to delete this License!
                </SweetAlert>
                <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={this.state.openSnack}
                autoHideDuration={3000}
                onClose={() => this.setState({openSnack: false})}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{this.state.messageSnack}</span>}
                action={[
                    <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    onClick={() => this.setState({openSnack: false})}
                    >
                    <CloseIcon />
                    </IconButton>
                ]}
                />
            
                <Dialog
            fullScreen
            open={this.state.openDialog} 
            onClose={() => this.handleSave('batal')}
            TransitionComponent={Transition}>
            <AppBar className="position-relative">
                <Toolbar>
                    {/* <IconButton color="inherit" onClick={() => this.handleSave('batal')} aria-label="Close">
                        <CloseIcon />
                    </IconButton> */}
                    <Typography variant="h6" type="title" color="inherit" style={{
                        flex: 20,
                    }}>
                        Operator
                    </Typography>
                    <Button 
                        variant="contained" 
                        className="bg-white text-black"
						disabled={loading} 
						onClick={() => { if(!loading) this.handleSave('batal') }}
					>
						cancel
					</Button>&nbsp;&nbsp;
					<Button 
                        variant="contained" 
                        color="primary"
						disabled={loading} 
						onClick={() => { if(!loading) this.handleSave('tambah') }}
					>
                        {loading ? (
                            <CircularProgress
                                className="text-white"
                                size={24}
                            />						  
                        ) : "save"}
                    </Button>
                </Toolbar>
            </AppBar>
            <div className="app-wrapper">
            <Paper className={classes.paper} elevation={1}>
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <Typography variant="h6" gutterBottom>
                            Form Driver
                        </Typography>
                        <Divider/>
                        
                        <Grid container spacing={24}>
                            <Grid item xs={6}>
                                <InputVirtual 
                                    required
                                    label="Perusahaan"
                                    value=""
                                    name="name"
                                    lengthData={20}
                                    url={BASE_URL_JAVAZ_API + "/company/search"}
                                    getData={this.handleGetSelVirCompanyAddForm}
                                    setData={[{name:"id",value:this.state.company.toString(),"logic_operator":"=","operator":"AND"}]}
                                    fullWidth={true}
                                    dialogForm="DialogFormCompany"
                                />
                            </Grid>
                            <Grid item xs={6}>
                            {/* <InputVirtual
                                    required
                                    label="Role Name"
                                    value=""
                                    name="role_name"
                                    lengthData={20}
                                    url={BASE_URL_JAVAZ_API + "/master-role/search"}
                                    getData={this.getInputRoleName}
                                    filter={[{name:"role_parent","logic_operator":"=",value:roleUser,"operator":"OR"},
                                             {name:"role_name","logic_operator":"=",value:roleUser,"operator":"OR"}]}
                                    fullWidth={true}
                                /> */}
                            </Grid>
                        </Grid>
                        
                        <TextField
                            autoFocus
                            margin="dense"
                            id="drivercode"
                            label="Kode Operator"
                            type="text"
                            onChange={(e) => this.setState({driver_code: e.target.value})}
                            fullWidth
                        />
                        <TextField
                            autoFocus
                            margin="dense"
                            id="rfid"
                            label="RFID"
                            type="text"
                            onChange={(e) => this.setState({rfid: e.target.value})}
                            fullWidth
                        />
                        <TextField
                            autoFocus
                            margin="dense"
                            id="driver_type"
                            label="Tipe Operator"
                            type="text"
                            onChange={(e) => this.setState({driver_type: e.target.value})}
                            fullWidth
                        />
                        <TextField
                            required
                            error={errorFullName}
                            autoFocus
                            margin="dense"
                            id="fullname"
                            label="Full Name"
                            type="text"
                            onChange={(e) => this.setState({name: e.target.value})}
                            fullWidth
                            
                        />
                        {errorFullName && <FormHelperText error={errorFullName} id="component-error-text">{messageFullName}</FormHelperText>}
                        
                        <Grid container spacing={24}>
                            <Grid item xs={6}>
                                {/* <TextField
                                    required
                                    autoFocus
                                    margin="dense"
                                    id="username"
                                    label="Username"
                                    type="text"
                                    onChange={(e) => this.setState({username: e.target.value})}
                                    fullWidth
                                /> */}
                                {/* <InputVirtual 
                                    label="Vehicle"
                                    value=""
                                    name="license_plate"
                                    lengthData={20}
                                    url={BASE_URL_JAVAZ_API + "/vehicle/search"}
                                    getData={this.getInputVehicle}
                                    fullWidth={true}
                                    dialogForm="DialogFormVehicle"
                                /> */}
                                <DatePicker
                                    fullWidth
                                    clearable
                                    label="Tanggal Lahir"
                                    value={this.state.birth_date}
                                    format="MMMM Do YYYY"
                                    onChange={this.handleDateChange}
                                    animateYearScrolling={false}
                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                />
                                <DatePicker
                                    fullWidth
                                    clearable
                                    label="Tanggal Dipekerjakan"
                                    value={this.state.hired_date}
                                    format="MMMM Do YYYY"
                                    onChange={this.handleDateChange3}
                                    animateYearScrolling={false}
                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    required
                                    autoFocus
                                    margin="dense"
                                    id="email"
                                    label="Email"
                                    type="email"
                                    onChange={(e) => this.setState({email: e.target.value})}
                                    fullWidth 
                                />
                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    id="imeino"
                                    label="Imei No"
                                    type="text"
                                    onChange={(e) => this.setState({imei_no: e.target.value})}
                                    fullWidth 
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="password"
                                    label="Password"
                                    type="password"
                                    onChange={(e) => this.setState({password: e.target.value})}
                                    fullWidth
                                /> */}
                                <TextField
                                    autoFocus
                                    id="phone"
                                    label="Nomor HP"
                                    type="number"
                                    onChange={(e) => this.setState({mobile_no: e.target.value})}
                                    fullWidth
                                />
                                
                            </Grid>
                        </Grid>
                        
                        <TextField
                            autoFocus
                            margin="dense"
                            id="place"
                            label="Tempat Lahir"
                            type="email"
                            onChange={(e) => this.setState({birth_place: e.target.value})}
                            fullWidth
                        />
                        
                        <TextField
                            autoFocus
                            margin="dense"
                            id="address"
                            label="Alamat"
                            type="text"
                            onChange={(e) => this.setState({address: e.target.value})}
                            fullWidth
                        />
                    
                        {/* <FormControlLabel
                                value="left"
                                control={
                                    <Switch
                                    checked={this.state.absent}
                                    onChange={(e) => this.setState({absent: e.target.checked})}
                                    value="isActive"
                                    color="primary"
                                    />
                                }
                                label="Absent "
                        /> */}
                            <Grid container spacing={24}>
                                    <Grid item xs={6}>
                                        
                                        <br/>
                                        <Paper className={classes.paper} elevation={1}>
                                            <img width="100%" height="150" src={this.state.front_image !== null ? this.state.front_image : 'https://via.placeholder.com/150x150'} style={{
                                                borderRadius: 5,
                                                boxShadow:  '0 0 7px 2px rgba(204,204,204,0.7)'
                                            }} />
                                        </Paper><br/>
                                        <input 
                                            onChange={this.getFrontPhoto} 
                                            style={{display: 'none'}} 
                                            type="file"
                                            ref={fileInputFront => this.fileInputFront = fileInputFront} />
                                        <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputFront.click()}>
                                            <Backup /> &nbsp;&nbsp;
                                            <span>Upload Photo</span>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControlLabel
                                                value="left"
                                                control={
                                                    <Switch
                                                    checked={this.state.status}
                                                    onChange={(e) => this.setState({status: e.target.checked})}
                                                    value="isActive"
                                                    color="primary"
                                                    />
                                                }
                                                label="Status "
                                        />
                                    </Grid>
                                </Grid>
                        
                        <br/><br/>
                       
                    </Grid>
                    <Grid item xs={6}>
                            <Typography variant="h6" gutterBottom style={{marginLeft: 20}}>
                              <i className="zmdi zmdi-assignment"></i>&nbsp; Tambahkan SIM Operator
                          </Typography>
                          <Divider/><br/>
                        <ExpansionPanel defaultExpanded={false}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <div >
                                <Typography> <i className="zmdi zmdi-plus zmdi-hc-lg"></i>&nbsp;&nbsp; Tambahkan SIM</Typography>
                            </div>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                            <Grid container spacing={24}>
                                <Grid item xs={12}>

                                <InputVirtual 
                                    label="License Type"
                                    value=""
                                    name="license_name"
                                    lengthData={20}
                                    url={BASE_URL_JAVAZ_API + "/driver-license/search"}
                                    getData={this.getInputDriverLicense}
                                    fullWidth={true}
                                    dialogForm="DialogFormDriverLicense"
                                />
                            
 
                                <DatePicker
                                    fullWidth
                                    clearable
                                    label="Expire Date"
                                    value={this.state.license_exp_date}
                                    format="MMMM Do YYYY"
                                    onChange={(date) => this.setState({license_exp_date: date})}
                                    animateYearScrolling={false}
                                    leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                    rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="license_no"
                                    label="License Number"
                                    type="number"
                                    value={this.state.license_no}
                                    onChange={(e) => this.setState({license_no: e.target.value})}
                                    fullWidth
                                />

                                <Grid container spacing={24}>
                                    <Grid item xs={6}>
                                        <br/>
                                        <Paper className={classes.paper} elevation={1}>
                                            <img width="100%" height="150" src={this.state.front_image_license !== null ? this.state.front_image_license : 'https://via.placeholder.com/150x150'} style={{
                                                borderRadius: 5,
                                                boxShadow:  '0 0 7px 2px rgba(204,204,204,0.7)'
                                            }} />
                                        </Paper><br/>
                                        <input 
                                            onChange={this.getFrontPhotoLicense} 
                                            style={{display: 'none'}} 
                                            type="file"
                                            ref={fileInputFrontLicense => this.fileInputFrontLicense = fileInputFrontLicense} />
                                        <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputFrontLicense.click()}>
                                            <Backup /> &nbsp;&nbsp;
                                            <span>Upload Front Photo</span>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                    <br/>
                                        <Paper className={classes.paper} elevation={1}>
                                            <img width="100%" height="150" src={this.state.back_image_license !== null ? this.state.back_image_license : 'https://via.placeholder.com/150x150'} style={{
                                                borderRadius: 5,
                                                boxShadow:  '0 0 7px 2px rgba(204,204,204,0.7)'
                                            }} />
                                        </Paper><br/>
                                        <input 
                                            onChange={this.getBackPhotoLicense} 
                                            style={{display: 'none'}} 
                                            type="file"
                                            ref={fileInputBackLicense => this.fileInputBackLicense = fileInputBackLicense} />
                                        <Button variant="contained" color="primary" className="btn jr-btn-rounded btn-rounded btn-block" onClick={() => this.fileInputBackLicense.click()}>
                                            <Backup /> &nbsp;&nbsp;
                                            <span>Upload Back Photo</span>
                                        </Button>
                                    </Grid>
                                </Grid>
                                
                                <br/><br/>
                                
                                </Grid>
                            </Grid>
                            </ExpansionPanelDetails>
                            <Divider />
                            <ExpansionPanelActions>
                            <Button size="small" onClick={() => this.handleAddLicenseDriver('batal')}>
                                Cancel
                            </Button>
                            <Button size="small" color="primary" onClick={() => this.handleAddLicenseDriver('tambah')}>
                                Save
                            </Button>
                            </ExpansionPanelActions>
                        </ExpansionPanel>
                        <br/><br/>
                      <div className="sticky-container">
                          <Typography variant="h6" gutterBottom style={{marginLeft: 20}}>
                              <i className="zmdi zmdi-assignment"></i>&nbsp; Daftar SIM Operator
                          </Typography>
                          <Divider/>
                        <Dialog
                            fullWidth="true"
                            maxWidth="sm"
                            open={this.state.imageDialog}
                            onClose={() => this.setState({imageDialog: false})}
                            TransitionComponent={Transition}
                            keepMounted
                            aria-labelledby="alert-dialog-slide-title"
                            aria-describedby="alert-dialog-slide-description"
                        >
                            <DialogTitle id="max-width-dialog-title">Image License</DialogTitle>
                            <DialogContent>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Card className="shadow border-0">
                                                <CardImg top width="100%" src={this.state.urlFrontImage} alt="Card image cap" />
                                                <CardBody>
                                                    <h3 className="card-title">Front Image</h3>
                                                </CardBody>
                                            </Card>
                                        </div>
                                        <div className="col-md-6">
                                            <Card className="shadow border-0">
                                                <CardImg top width="100%" src={this.state.urlBackImage} alt="Card image cap" />
                                                <CardBody>
                                                    <h3 className="card-title">Back Image</h3>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                            </DialogContent>
                            <DialogActions>
                                <Button variant="contained" className="bg-white text-black" onClick={() => this.setState({imageDialog: false})}>
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                          {licenseData.length > 0 ? (
                              <License license={licenseData} deleteLicense={this.handleRemoveLicense} handleShowImage={this.handleImageLicense}/>
                          ):(
                            <div style={{margin: '20% 0 0 40%'}}>
                              <i className="zmdi zmdi-alert-triangle zmdi-hc-5x" style={{opacity: '0.3', marginLeft: 20}}></i>
                              <Typography>Tidak ada SIM yang Terdaftar</Typography>
                            </div>
                              
                          )}
                      </div>
                    </Grid>
                </Grid>
                </Paper>
            </div>
                
        </Dialog>
        </React.Fragment>
        );
    }
}

export default withStyles(styles)(DialogAdd);


// WEBPACK FOOTER //
// ./app/routes/MasterDriver/DialogAdd.js